import styled from '@emotion/styled';
import { breakpoints, radius, spacing } from '@naf/theme';
import { Text } from '@naf/text';

export const ImageWrapper = styled.div`
  position: relative;
  margin: ${spacing.space80} auto 0;
  padding: 0;
  width: 100%;

  @media (max-width: ${breakpoints.m}) {
    margin-top: ${spacing.space24};
  }
`;

export const ImageFigure = styled.figure`
  margin: 0;
  position: relative;
  overflow: hidden;
  border-top-left-radius: ${radius.l};
  border-top-right-radius: ${radius.l};

  img {
    width: 100%;
    max-height: 512px;
    object-fit: cover;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40%;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  }
`;

export const StyledHeaderText = styled(Text)`
  margin: ${spacing.space32} 0 ${spacing.space16} 0;
`;
